<po-page-default p-title="Lançamentos" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <po-container class="po-lg-12 po-md-12 po-sm-12">
      <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
        <span class="an an-file-arrow-up"></span>
        Importação de lançamentos contábeis
      </span>

      <div class="po-lg-12 po-mb-4">
        <po-radio-group
          name="tipoLancamento"
          p-label="Tipo de lançamento"
          [p-columns]="2"
          [(ngModel)]="tipoLancamento"
          [p-options]="tipoLancamentoOptions">
        </po-radio-group>
      </div>

      <!-- ========== Lançamento comum (planilha) ========== -->
      <ng-container *ngIf="tipoLancamento === 'comum'">
        <div class="po-lg-11 po-md-9 po-sm-8 po-mb-5 destaque">
          <p class="po-font-text-large po-mb-1">
            Envie uma planilha com os lançamentos contábeis. Os lançamentos serão registrados automaticamente
            no sistema.
          </p>
          <p><b>&nbsp;&nbsp; - Utilize exclusivamente o modelo oficial de planilha.</b></p>
          <p>
            <b>&nbsp;&nbsp; - Formatos aceitos: CSV, XLSX ou XLS.</b>
            <a href="/assets/modelo/Modelo_Lancamento.xlsx" download="Modelo_Lancamento.xlsx" style="margin-left: 8px;">
              Baixe o modelo
            </a>
          </p>
          <p class="po-mb-1"><b>&nbsp;&nbsp; - Colunas obrigatórias do modelo:</b></p>
          <p class="modelo-colunas">{{ modeloColunas.join(' | ') }}</p>
          <p class="po-font-text po-mt-1">
            <b>&nbsp;&nbsp; - Opcional:</b> informe empresa (código Domínio) e usuário abaixo para não repetir essas colunas na planilha.
          </p>
        </div>

        <div class="po-row po-mb-3">
          <div class="po-lg-6 po-md-12">
            <app-empresa-combo
              name="codigoEmpresaImportacao"
              label="Empresa (opcional)"
              placeholder="Código Domínio ou nome da empresa..."
              help="Se informada, todos os lançamentos usarão esta empresa. Caso contrário, use a coluna CodigoEmpresa na planilha."
              [required]="false"
              [(ngModel)]="codigoEmpresaOpcional">
            </app-empresa-combo>
          </div>
          <div class="po-lg-6 po-md-12">
            <po-input
              name="usuarioImportacao"
              p-label="Usuário Domínio (opcional)"
              p-placeholder="Ex.: USUARIO1"
              p-help="Se informado, substitui a coluna Usuario da planilha."
              p-clean="true"
              [(ngModel)]="usuarioOpcional">
            </po-input>
          </div>
        </div>

        <div class="po-lg-6 planilha-col">
          <label class="po-field-title">Planilha (CSV/XLSX/XLS)</label>
          <div class="dropzone" (drop)="onDropArquivo($event)" (dragover)="onDragOverArquivo($event)">
            Arraste o arquivo aqui ou
            <input type="file" accept=".csv,.xlsx,.xls" (change)="onArquivoSelecionado($event)" />
          </div>
          <p class="po-font-text" *ngIf="arquivoNome">
            Arquivo: <b>{{ arquivoNome }}</b>
            <a style="margin-left: 8px; cursor: pointer;" (click)="limparArquivo()">Limpar</a>
          </p>
        </div>

        <po-button
          class="po-lg-3 po-mt-4"
          p-label="Visualizar planilha"
          p-kind="secondary"
          (p-click)="visualizarPlanilha()"
          [p-loading]="parsingPlanilha"
          [p-disabled]="!planilhaCarregada || parsingPlanilha">
        </po-button>

        <po-button
          class="po-lg-3 po-mt-4"
          p-label="Importar Lançamentos"
          (p-click)="importarLancamentos()"
          [p-loading]="loading"
          [p-disabled]="!arquivoPlanilha || parsingPlanilha">
        </po-button>

        <div class="po-lg-12 po-mt-4" *ngIf="showProgress">
          <div class="progress-section">
            <div class="progress-header">
              <i class="an an-timer"></i>
              <span>Progresso da Importação</span>
            </div>

            <div class="progress-body">
              <div class="progress-steps">
                <div class="status-row">
                  <div class="step-dot done"></div>
                  <div>
                    <p class="status-title">Solicitação enviada</p>
                    <p class="status-desc" *ngIf="inicioProcessamento">
                      {{ inicioProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </p>
                  </div>
                </div>

                <div class="status-row">
                  <div
                    class="step-dot"
                    [ngClass]="{
                      processing: processoStatus === 'PROCESSANDO',
                      done: processoStatus === 'PRONTO',
                      partial: processoStatus === 'PARCIAL',
                      blocked: processoStatus === 'BLOQUEADO'
                    }"></div>
                  <div>
                    <p class="status-title">Status atual: {{ getStatusLabel() }}</p>
                    <p class="status-desc">{{ processoMensagem }}</p>
                  </div>
                </div>

                <div class="status-row" *ngIf="fimProcessamento">
                  <div
                    class="step-dot"
                    [ngClass]="{
                      done: processoStatus === 'PRONTO',
                      partial: processoStatus === 'PARCIAL',
                      blocked: processoStatus === 'BLOQUEADO'
                    }"></div>
                  <div>
                    <p class="status-title">Finalizado</p>
                    <p class="status-desc">{{ fimProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
                  </div>
                </div>
              </div>

              <div class="aviso" *ngIf="processoStatus === 'PRONTO' && fimProcessamento">
                <i class="an an-info"></i>
                <p>Lançamentos importados com sucesso.</p>
              </div>

              <div class="aviso aviso-parcial" *ngIf="processoStatus === 'PARCIAL' && fimProcessamento">
                <i class="an an-warning"></i>
                <p>
                  Parte dos lançamentos foi importada. Revise os itens abaixo, corrija a planilha e envie
                  novamente se necessário.
                </p>
              </div>

              <div class="aviso aviso-erro" *ngIf="processoStatus === 'BLOQUEADO' && fimProcessamento">
                <i class="an an-warning-circle"></i>
                <p>
                  As alterações na base de dados não foram realizadas. Corrija a planilha conforme o problema
                  indicado abaixo e tente novamente.
                </p>
              </div>

              <div
                class="empresas-status-list"
                *ngIf="processosEmpresas.length > 0 && processoStatus !== 'PRONTO'">
                <div class="status-row" *ngFor="let item of processosEmpresas">
                  <div
                    class="step-dot"
                    [ngClass]="{
                      processing: item.status === 'PROCESSANDO',
                      done: item.status === 'PRONTO',
                      partial: item.status === 'PARCIAL',
                      blocked: item.status === 'BLOQUEADO'
                    }"></div>
                  <div>
                    <p class="status-title">
                      <b>{{ item.codigo }}</b> — {{ getStatusLabelEmpresa(item.status) }}
                    </p>
                    <p class="status-desc">{{ item.mensagem }}</p>
                    <p class="status-meta">{{ item.atualizadoEm | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ========== DARF / e-CAC (PDF) ========== -->
      <ng-container *ngIf="tipoLancamento === 'darf'">
        <div class="po-lg-11 po-md-9 po-sm-8 po-mb-5 destaque">
          <p class="po-font-text-large po-mb-1">
            Envie um ou mais comprovantes PDF (DARF / DAS / e-CAC). Cada arquivo gera os lançamentos
            contábeis automaticamente.
          </p>
          <p><b>&nbsp;&nbsp; - Formato aceito: PDF.</b></p>
          <p><b>&nbsp;&nbsp; - É possível selecionar vários PDFs de uma vez.</b></p>
          <p>
            <b>&nbsp;&nbsp; - A empresa é identificada pelo CNPJ do documento.</b>
          </p>
        </div>

        <div class="po-row po-mb-3">
          <div class="po-lg-4 po-md-6">
            <po-number
              name="contaCreditoPdf"
              p-label="Conta crédito (opcional)"
              p-placeholder="Ex.: 612"
              p-help="Se vazio, usa a configuração padrão da API."
              p-clean="true"
              [(ngModel)]="contaCreditoOpcional">
            </po-number>
          </div>
          <div class="po-lg-4 po-md-6">
            <po-input
              name="usuarioPdf"
              p-label="Usuário Domínio (opcional)"
              p-placeholder="Ex.: SISTEMA"
              p-help="Usuário gravado no lançamento contábil."
              p-clean="true"
              [(ngModel)]="usuarioOpcional">
            </po-input>
          </div>
        </div>

        <div class="po-lg-12">
          <po-upload
            #uploadPdf
            [p-restrictions]="pdfRestrictions"
            p-size="medium"
            [p-drag-drop]="true"
            [p-multiple]="true"
            [p-drag-drop-height]="150"
            [p-url]="urlPlaceholder"
            [p-hide-send-button]="true"
            p-label="PDFs de pagamento">
          </po-upload>
        </div>

        <po-button
          class="po-lg-4 po-mt-3"
          p-icon="an an-paper-plane-tilt"
          p-label="Importar PDFs"
          (p-click)="importarPdfs()"
          [p-loading]="loadingPdf"
          [p-disabled]="loadingPdf">
        </po-button>

        <div class="po-lg-12 po-mt-4" *ngIf="showProgressPdf">
          <div class="progress-section">
            <div class="progress-header">
              <i class="an an-timer"></i>
              <span>Progresso dos PDFs</span>
            </div>

            <div class="progress-body">
              <div class="status-row" *ngIf="inicioProcessamentoPdf">
                <div class="step-dot done"></div>
                <div>
                  <p class="status-title">Início</p>
                  <p class="status-desc">{{ inicioProcessamentoPdf | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
                </div>
              </div>

              <div class="empresas-status-list" *ngIf="processosPdf.length > 0">
                <div class="status-row" *ngFor="let item of processosPdf">
                  <div
                    class="step-dot"
                    [ngClass]="{
                      processing: item.status === 'PROCESSANDO',
                      done: item.status === 'PRONTO',
                      blocked: item.status === 'BLOQUEADO'
                    }"></div>
                  <div>
                    <p class="status-title">
                      <b>{{ item.nomeArquivo }}</b> — {{ getStatusLabelPdf(item.status) }}
                    </p>
                    <p class="status-desc">{{ item.mensagem }}</p>
                    <p class="status-meta" *ngIf="item.requestId">RequestId: {{ item.requestId }}</p>
                  </div>
                </div>
              </div>

              <div class="status-row" *ngIf="fimProcessamentoPdf">
                <div class="step-dot done"></div>
                <div>
                  <p class="status-title">Finalizado</p>
                  <p class="status-desc">{{ fimProcessamentoPdf | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </po-container>
  </div>
</po-page-default>

<po-modal
  #modalPlanilha
  class="modal-planilha-excel"
  p-size="xl"
  [p-title]="'Planilha: ' + arquivoNome"
  p-icon="an an-file-xls"
  p-click-out="false"
  (p-close)="fecharVisualizacaoPlanilha()">
  <div class="excel-preview-wrap">
    <table class="excel-preview-table">
      <thead>
        <tr>
          <th class="excel-corner"></th>
          <th *ngFor="let col of colunasExcel" class="excel-col-label">{{ col }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of planilhaGrid; let rowIndex = index">
          <th class="excel-row-label">{{ rowIndex + 1 }}</th>
          <td
            *ngFor="let col of colunasExcel; let colIndex = index"
            [class.excel-header-cell]="rowIndex === 0">
            {{ row[colIndex] || '' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <po-modal-footer>
    <po-button p-label="Fechar" (p-click)="fecharVisualizacaoPlanilha()"></po-button>
  </po-modal-footer>
</po-modal>
